// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"22":"7a1bff3b","226":"908873b5","362":"581cafc3","513":"a00c0c1b","937":"5ec10476","951":"1711ec41"}[chunkId] + ".css";
};